import type { BoxProps } from '@withjoy/joykit';
import { Box } from '@withjoy/joykit';
import React from 'react';

interface TileGridProps {
  children: React.ReactNode;
  columns?: BoxProps['gridTemplateColumns'];
}

// Fixed `calc()` tracks, NOT `1fr`/`minmax(0, 1fr)`. A flexible `fr` track is sized by an
// algorithm that still consults item content during layout, and in Safari a fast zoom
// (overshoot past ~120% then snap back) makes the nested `aspect-ratio` tiles + the JS card
// scaler transiently inflate a column; the wrong width then latches until reload. A track
// defined as a fixed length — `(100% - total gap) / N` — is resolved purely from the
// container width and can never be influenced by content, so columns stay exactly equal
// through any zoom. Gap is 3px (see the grid `gap` below); keep the two in sync.
const DEFAULT_RESPONSIVE_COLUMNS: TileGridProps['columns'] = {
  _: 'repeat(2, calc((100% - 3px) / 2))',
  sm2: 'repeat(3, calc((100% - 6px) / 3))',
  md3: 'repeat(4, calc((100% - 9px) / 4))',
  lg: 'repeat(5, calc((100% - 12px) / 5))',
  xl: 'repeat(6, calc((100% - 15px) / 6))',
};

export const TileGrid = (props: TileGridProps) => {
  const { children, columns = DEFAULT_RESPONSIVE_COLUMNS } = props;

  return (
    <Box
      display="grid"
      maxWidth="100%"
      gridTemplateColumns={columns}
      alignItems="start"
      gap="3px"
      paddingBottom={8}
    >
      {children}
    </Box>
  );
};
